import React,{ useState, useEffect, useRef } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Menu, Tooltip, IconButton } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import Box from '@mui/material/Box';
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from "@mui/material/Autocomplete";
import {getInventoryDeployedData, getInventoryDeployedDataCount, moveDeviceToWarehouse, deleteSite, inventoryDownloadConfig, clearInventoryConfigDownload, inventoryChangeGroup, backupConfigNow, rebootDevice} from "../../actions/Users/authenticateInventory"
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import _ from "lodash";
import { DEFAULT_PAGE_SIZE, NEW_PER_PAGE_ITEMS } from "../../constants/Constants";
import { checkLoggedInUserAuthorizedToViewPage, checkSelectedOuIsInvitedOu, convertDateTimeIntoTimezone, generatePDFfile, getDecodeURI, getEncodedURI, getInvitedOuList, redirectToTopolgyTabs, handleValidateTier } from "../../utils/util";
import { PER_PAGE_ITEMS } from "../../constants/Constants";
import Paper from "@material-ui/core/Paper";
import Stack from "@mui/material/Stack";
import ascSortingSelected from "../../asset/image/ascSortingSelected.svg";
import descSortingSelected from "../../asset/image/descSortingSelected.svg";
import AscSort from "../../asset/image/AscSort.svg";
import DescSort from "../../asset/image/DescSort.svg";
import TokenGenration from  "../../asset/image/tokenGenration.svg";
import { Link } from "react-router-dom";
import "./inventoryDeployed.css"
import DeleteIcon from "../../asset/image/user_delete.svg";
import WarehouseIcon from "../../asset/image/warehouse.svg";
import ConfirmDialog from "../../components/ConfirmDialog";
import {
  CONFIRM_DIALOG_TITLE
} from "../../config";
import { SERVICE_FUNCTION_TO_FEATURE } from '../../config';
import { DEFAULT_TIMEZONE, DEFAULT_DATE_FORMAT, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from "../../utils/constants";
import moment from "moment-timezone";
import { toast } from "react-toastify";
import DP_Dropdown from "../InventoryWarehouseTable/DP_Dropdown";
import close from "../../asset/image/close.svg";
import changeGroupIcon from "../../asset/image/changeGroup.svg";
import { updateUserOuHasSubOus } from "../../actions/Users/authenticate";
import { displayToastError } from "../../server/request";
import GetApp from "@material-ui/icons/GetApp";
import { DOWNLOAD_INVENTORY_DEPLOYED_DATA, GET_CSV_DATA_TO_DOWNLOAD, GET_INVENTORY_DEPLOYED_DATA, INVENTORY_ASSIGN_DEVICE_TO_WAREHOUSE, GET_UPGRADE_INVENTORY_LICENSE, GET_DEREGISTER_DEVICE, GET_DEVICE_TRANSFER, GET_INVENTORY_SYNC_DATA, TRACK_INVENTORY_SYNC_DATA, GET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS } from "../../actions/types";
import ApplyConfig from "./ApplyConfig";
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { BackupConfigNow } from "./BackupConfigNow";
import { compare } from 'compare-versions';
import { Pagination } from "../Pagination";
import { AddBoxSharp } from "@mui/icons-material";
import SoftwareUpgrade from "./SoftwareUpgrade";
import RotateRightOutlinedIcon from '@mui/icons-material/RotateRightOutlined';
import Download from '../../asset/image/DownloadUsage.svg';
import { CsvParameters, downloadAsCSV } from "../../actions/Users/authenticateCsvDownload";
import DownloadCSV, { clearCsvDownload } from "../DownloadCSV";
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import UpdatesGoingOn from "../../asset/image/updates_going_on.svg";
import DeviceHistoryPopup from "./DeviceHistoryPopup";
import SettingsIcon from '@mui/icons-material/Settings';
import EditActionsPopup from "./EditActionsPopup";
import CircleIcon from '@mui/icons-material/Circle';
import DeviceEosHistoryPopup from "./DeviceEosHistoryPopup";
import DeviceLicenseHistoryPopup from "./DeviceLicenseHistoryPopup";
import TuneIcon from "@mui/icons-material/Tune";
import InventoryFilters from "./InventoryFilters";
import InventoryPopup from "../../UserScreen/InventoryPage/InventorySettings/InventoryPopup";
import CustomLoader from "../Loader/CustomLoader";


export const T0_TIER = "T0"
export const T91_TIER = "T91"
export const T101_TIER = "T101"
export const T103_TIER = "T103"

const convertToCsv = (data: any[][], userTimezone: string) => {
  const [_columns, ...rows] = data;
  const csvRows: any[] = [];
  rows.forEach(row => {
    const hierarchy = row[35] ? row[35].replace(/\//g, ' / ') : '';
    const pauseDate = row[36] ? `="${moment(row[36]?.split(' ')?.[0], 'YYYY-MM-DD').format('MM/DD/YYYY')}"` : '';    
    csvRows.push([row[3], row[0], row[5], row[17], row[4], convertDateTimeIntoTimezone(row[16], userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS), convertDateTimeIntoTimezone(row[6], userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS), row[33], row[18], row[24], row[19], convertDateTimeIntoTimezone(row[13], userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS), convertDateTimeIntoTimezone(row[14], userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS), convertDateTimeIntoTimezone(row[9], userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS), hierarchy, pauseDate])
  })
  let lastSeen = 'Last Seen (' + userTimezone + ')'
  let regDate = 'Reg. Date (' + userTimezone + ')'
  let licenseExpDate = 'License Exp. Date (' + userTimezone + ')'
  let uptimeSince = 'Uptime Since (' + userTimezone + ')'
  let savedConfig = 'Saved Config (' + userTimezone + ')'

  return [['Site', 'Organization', 'Device name', 'EOS Version', 'DID', lastSeen, regDate, 'Reg. By', 'License', 'License Type', 'Term', licenseExpDate, uptimeSince, savedConfig, 'Org Hierarchy', 'Pause Date'], ...csvRows]
}

const InventoryDeployedTable = (props) => {
  const { authReducer, errorReducer, getInventoryDeployedData, location, history, permissionChanges, getInventoryDeployedDataCount, moveDeviceToWarehouse, deleteSite, inventoryDownloadConfig, clearInventoryConfigDownload, inventoryChangeGroup, backupConfigNow, updateUserOuHasSubOus,
    downloadAsCSV, rebootDevice, isReadOnlyUser, getDeviceTransfer, getInventorySyncData } = props;
  let _q = getDecodeURI(location?.search);
  let [inventoryDeployedData, setInventoryDeployedData] = useState<any[]>([]);

  const VESSEL_NAME = "name";
  const GROUP_NAME = "dpname";
  const DEVICE_NAME = "deviceName";
  const PRODUCT_ID = "productId";
  const LAST_SEEN = "last_seen";
  const REG_DATE = "dateRegistered"
  const LICENSE_EXP_DATE = "license_expiry_date";
  const UPTIME_SINCE = "uptime_date";
  const CURRENT_EOS_VERSION = "e_software_version";
  const EOS_VERSION = "software_version";
  const CONFIG_BACK_UP_CREATE_TIME = "create_time";
  const ASC_ORDER = "asc";
  const DESC_ORDER = "desc";

  let [searchValue, setSearchValue] = useState<any>(_q.hasOwnProperty("search") ? _q.search : "");
  const ENTER_KEY_CODE = "Enter";
  const [fromItem, setFromItem] = useState<number>(0);
  const [toItem, setToItem] = useState<number>(0);
  const [total, setTotal] = React.useState(0);
  const [page, setPage] = useState<any>(_q.hasOwnProperty("page") ? parseInt(_q.page) : 0)
  const [pages, setPages] = React.useState(0);
  const [limit, setLimit] = useState<any>(_q.hasOwnProperty("limit") ? _q.limit : DEFAULT_PAGE_SIZE);
  const [currentPageItemType, setCurrentPageItemType] = React.useState("Devices");
  const [sort, setSort] = useState<any>(_q.hasOwnProperty("sort") ? _q.sort : REG_DATE);
  const [sortOrder, setSortOrder] = useState<any>(_q.hasOwnProperty("sortOrder") ? _q.sortOrder : DESC_ORDER);
  const [selectedOu, setSelectedOu ] = useState<any>(_q.hasOwnProperty("ouName") && _q.ouName!=="K4Mobility" ? `and fullname IN ('${_q.ouName}')` : "");
  const [isOpenEdgeDevice, setIsOpenEdgeDevice] = useState<boolean>(false)
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
    onConfirm: {},
  });
  const [locationIds, setLocatioIds] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const VIEW_INVENTORY = "view-inventory";
  const viewDeployedService = SERVICE_FUNCTION_TO_FEATURE[VIEW_INVENTORY]['service'];
  const viewDeployedFunction = SERVICE_FUNCTION_TO_FEATURE[VIEW_INVENTORY]['function'];
  const [downloadConfig, setDownloadConfig] = useState(false);
  const [changeGroupPopup, setChangeGroupPopup] = useState(false);
  const [ou, setOu] = useState<any>({});
  const [selectedSiteId, setselectedSiteIdId] = useState('');
  const [selectedSiteName, setSelectedSiteName] = useState('');
  const [dpName, setDpName] = useState('');
  const [invitedOus, setInvitedOus] = useState<any[]>([])
  const [isSelectedOuIsUserOu, setIsSelectedOuIsUserOu] = useState(false)
  const [modifyConfigData, setModifyConfigData] = useState<any>();
  const isAuthorizedToBeta= checkLoggedInUserAuthorizedToViewPage(SERVICE_FUNCTION_TO_FEATURE["beta-feature"]["service"], SERVICE_FUNCTION_TO_FEATURE["beta-feature"]["function"]);

  const MODIFY_CONFIG = "modify_config"
  const BACKUP_CONFIG_NOW = "backup-config-now"
  const EOS_UPGRADE = "eos-upgrade"

  const [clickedActionIcon, setClickedActionIcon] = useState("")
  const searchTimeoutRef = useRef<any>();
  const dispatch = useDispatch();
  const [deviceIdSelected, setDeviceIdSelected] = useState('');
  const [inventoryId, setInventoryId] = useState('');
  const [editActionsPopup, setEditActionsPopup] = useState(false);
  const [row, setRow] = useState<any>({});
  const [upgradeLicensePayload, setUpgradeLicensePayload] = useState<any>({});
  const [deviceHistoryPopup, setDeviceHistoryPopup] = useState(false);
  const [deviceEosHistoryPopup, setDeviceEosHistoryPopup] = useState(false);
  const [siteIdSelected, setSiteIdSelected] = useState('');
  const [deviceLicenseHistoryPopup, setDeviceLicenseHistoryPopup] = useState(false);
  const [isDeregQueueChecked, setIsDeregQueueChecked] = useState(false);
  const [filterPopup, setFilterPopup] = useState(false);
  const [anchorElRef, setAnchorElRef] = useState<HTMLElement | null>(null);
  const [isLicenseChanging, setIsLicenseChanging] = useState(false);
  const isLicenseChangingRef = useRef(false);

let deregQFromUrl = _q.deregQ ? decodeURIComponent(_q.deregQ).trim() : "";

let payload = {
  pageStart: ((page) * limit),
  pagesize: limit,
  search: searchValue,
  sortBy: sort,
  sortOrder: sortOrder,
  dp: selectedOu,
  k4Ids: locationIds,
  deregQ: deregQFromUrl || (isDeregQueueChecked ? "and deRegisteredQueueFlag=1" : "")
};

  

  function fetchInventoryDeployedData(payload){
    getInventoryDeployedData(payload, GET_INVENTORY_DEPLOYED_DATA);
    getInventoryDeployedDataCount(payload);
}

useEffect(() => {
  if (
    authReducer.csvDataDownloded &&
    authReducer.csvDataDownloded.length > 0 &&
    authReducer.csvDownloadId === 'inventory-deployed'
  ) {
    DownloadCSV(convertToCsv(authReducer.csvDataDownloded, authReducer.userTimezone), {
        formatters: {
          0: 'ESC-COMMA',
          1: 'ESC-COMMA',
          2: 'ESC-COMMA',
          5: 'ESC-COMMA',
          6: 'ESC-COMMA',
          11: 'ESC-COMMA',
          12: 'ESC-COMMA',
          13: 'ESC-COMMA',
          14: 'ESC-COMMA'
        },
      });
      return () => {
        dispatch(clearCsvDownload())
      }
  }
}, [authReducer.csvDataDownloded, authReducer.csvDownloadId]);


useEffect(() => {
  updateUserOuHasSubOus(authReducer)
  let invitedOuList = getInvitedOuList(authReducer.getOrganisationUnitList)
  setInvitedOus(invitedOuList)
}, [authReducer.getOrganisationUnitList])

useEffect(() => {
  if(invitedOus.length>0){
    let isSelectedOuIsInvitedOu = checkSelectedOuIsInvitedOu(authReducer.selectedOu, invitedOus)
    setIsSelectedOuIsUserOu(!isSelectedOuIsInvitedOu)
  }
}, [invitedOus])

useEffect(() => {
  if(!_.isEmpty(authReducer.getVesselsListing)) {
    let Vessels = [];
    const filteredVessels = authReducer?.filteredVessels;
    if (filteredVessels && filteredVessels.length > 0) {
        Vessels = filteredVessels;
    } else {
        Vessels = authReducer?.getVesselsListing?.locations;
    }
    // const k4Ids = authReducer?.getVesselsListing?.hasOwnProperty("locations") ? authReducer?.getVesselsListing?.locations : [];
    setLocatioIds(Vessels);
    if(Vessels?.length > 0) {
      fetchInventoryDeployedData({...payload, k4Ids: Vessels});
    } else {
      setInventoryDeployedData([]);
    }
  }
}, [authReducer.getVesselsListing, authReducer?.filteredVessels])

useEffect(() => {
  if (!_.isEmpty(authReducer.selectedOu) && authReducer.selectedOu.hasOwnProperty("id") && authReducer.selectedOu.id
      && authReducer.selectedOu.hasOwnProperty("name") && authReducer.selectedOu.name) {
      if(authReducer.selectedOu.name !== "K4Mobility"){
        setSelectedOu(`and fullname IN ('${authReducer.selectedOu.name}')`);
      }else{
        setSelectedOu("") 
      }
      setPage(0)
      setDpName(authReducer.selectedOu.name);
      setInventoryDeployedData([]);
      let isSelectedOuIsInvitedOu = checkSelectedOuIsInvitedOu(authReducer.selectedOu, invitedOus)
      setIsSelectedOuIsUserOu(!isSelectedOuIsInvitedOu)
  }
}, [authReducer.selectedOu]);

useEffect(() => {
  if (!_.isEmpty(errorReducer.errorFetchOuResources)) {
    displayToastError(errorReducer.errorFetchOuResources.description)
    errorReducer.errorFetchOuResources = {};
    setInventoryDeployedData([]);
  }
}, [errorReducer.errorFetchOuResources]);



  
const searchBoxKeyDown = (event: any) => {
  if (event && event.key === ENTER_KEY_CODE) {
      doSearch(searchValue);
  }
}

const doSearch = (value: string) => {
    let params: any = getDecodeURI(location?.search);
    value ? params.search = value: delete params.search;
    delete params.page;
    setPage(0);

    doNavigate(location.url, params);
    payload.search = value;
    fetchInventoryDeployedData({...payload, pageStart:0});
};

useEffect(() => {
  if (!_.isEmpty(authReducer.getInventoryDeployedData) && authReducer.getInventoryDeployedData.hasOwnProperty("data")) {
    const data = authReducer.getInventoryDeployedData.data
    if (data.hasOwnProperty("rows") && Array.isArray(data["rows"])) {
      const rows: any[] = data["rows"]
      let deployedData: any[] = [];
      for (let i = 0; i < rows?.length; i++) {
        let row = {};
        row["dpname"] = rows[i][0]
        row["dpId"] = rows[i][1]
        row["k4Id"] = rows[i][2]
        row["name"] = rows[i][3]
        row["sn"] = rows[i][4]
        row["deviceName"] = rows[i][5]
        row["dateRegistered"] = rows[i][6]
        row["deviceId"] = rows[i][7]
        row["productType"] = rows[i][8]
        row["create_time"] = rows[i][9]
        row["Path"] = rows[i][10]
        row["saved_config_file_name"] = ""
        if(!_.isEmpty(row["Path"])){
          if(row["Path"].includes("backups")){
            row["saved_config_file_name"] = row["Path"]?.split("backups")[1].replace("/","")
          } else {
            row["saved_config_file_name"] = row["Path"]
          }
        }
        row["EOS_Version"] = rows[i][11]
        row["config_id"] = rows[i][12]

        row["license_expiry_date"] = rows[i][13];

        const currentDate = moment();
        const expiry = moment(rows[i][13]);
        if(rows[i][13]) {
          const daysUntilExpiry = expiry.diff(currentDate, 'days');
          const isExpiringSoon = daysUntilExpiry <= 15;
          row['isExpiringSoon'] = isExpiringSoon;
        }
        
        row["uptime_date"] = rows[i][14]
  
        row["internet_status_flag"] = rows[i][15]

        row["last_seen"] = rows[i][16]
        row['inventoryId'] = rows[i][25]
        row['licenseType'] = rows[i][24]
        row['tierAlias'] = rows[i][18]
        row["termDisplay"]  = rows[i][19]
        row['tierValue'] = rows[i][27]
        row['termValue'] = rows[i][28]
        row['licenseTier'] = rows[i][32]
        row['deRegisteredDate'] = rows[i][20]
        row['hierarchy'] = rows[i][35]
        row['pausedOn'] = rows[i][36]?.split(' ')?.[0]
        row['resumeDate'] = rows[i][37]?.split(' ')?.[0]

        // do not show change group icon - if previous row and current row belongs to same site
        row["showChangeGroupIcon"] = true;
        if(i>0 &&  row["k4Id"]==deployedData[i-1]["k4Id"]){
          row["showChangeGroupIcon"] = false;
        }

        row["current_EOS_version"] = ""
        row["is_current_EOS_version_above_v6.5.3"] = false
        row["isLatestEOSavailable"] = false
        row["latestEOSavailable"]  = ""
        row["konnect_status"]  = rows[i][26]
        row["warranty"] = rows[i][30]
        row["warrantyStartDate"] = rows[i][31]
        if (!_.isEmpty(row["deviceId"]) && !_.isEmpty(rows[i][17])) {
          let deviceIdentifier = row["deviceId"].slice(0, 2);
          row["current_EOS_version"] = rows[i][17]?.split("~")[0]

          try {
            row["is_current_EOS_version_above_v6.5.3"] = compare(row["current_EOS_version"], '6.5.3', '>=')
            row["is_current_EOS_version_above_v6.5.2"] = compare(row["current_EOS_version"], '6.5.2', '>=')
          } catch (error) {
            console.log("error in version compare, current_EOS_version", row["current_EOS_version"])
          }

          row["inprogressFlag"]  = rows[i][21]
          row["action_status"]  = rows[i][22]
          row["action"]  = rows[i][23]
        }

        deployedData.push(row)
      }

      setInventoryDeployedData(deployedData)
    }
    authReducer.getInventoryDeployedData = {};
    setShowLoader(false);
    setEditActionsPopup(false);
    if (isLicenseChangingRef.current) {
      isLicenseChangingRef.current = false;
      setIsLicenseChanging(false);
    }
    setIsOpenEdgeDevice(false);
  }
}, [authReducer.getInventoryDeployedData])

useEffect(()=>{
    if (inventoryDeployedData?.length > 0) {
      const length = inventoryDeployedData?.length;
      const totalCount: number = parseInt(authReducer.getInventoryDeployedDataCount?.data?.rows[0][0]);
      const pages = Math.ceil(totalCount / limit);
      updatePageInfo(page, limit, length, pages, totalCount);
    } else {
      updatePageInfo(page, limit, 0, 1, 0);
    }
}, [authReducer.getInventoryDeployedDataCount, inventoryDeployedData])

useEffect(()=>{
  if (!_.isEmpty(authReducer.inventoryAssignDeviceToWarehouse)) {
    const res =authReducer.inventoryAssignDeviceToWarehouse;
    if(res?.message && (res?.error_code == 10011 || res?.error_code == 10035 || res?.error_code == 10015 || res?.error_code == 10055 || res?.error_code == 10056)) {
    } else if (res.hasOwnProperty("status") && res.status == 1) {
      const dp = authReducer.selectedOu.name == "K4Mobility" ? "" : `and fullname IN ('${authReducer.selectedOu.name}')`;
      const page = _q.hasOwnProperty("page") ? parseInt(_q.page) : 0;
      // setShowLoader(true);
      // setTimeout(() => {
      //   fetchInventoryDeployedData({ ...payload, dp: dp, pageStart: (page * limit) })
      // }, 30000);
      setEditActionsPopup(false);
      setIsOpenEdgeDevice(false);
      setConfirmDialog({ ...confirmDialog, subTitle: '', isOpen: false });
    } else {
      setEditActionsPopup(false);
      setIsOpenEdgeDevice(false);
      setConfirmDialog({ ...confirmDialog, subTitle: '', isOpen: false });
    }
    dispatch({type: INVENTORY_ASSIGN_DEVICE_TO_WAREHOUSE, payload: {}})
  }
}, [authReducer.inventoryAssignDeviceToWarehouse])

useEffect(()=>{
  if (!_.isEmpty(authReducer.inventoryDeleteSite)) {
    authReducer.inventoryDeleteSite = {}
    setEditActionsPopup(false);
    const dp = authReducer.selectedOu.name == "K4Mobility" ? "" : `and fullname IN ('${authReducer.selectedOu.name}')`;
    const page = _q.hasOwnProperty("page") ? parseInt(_q.page) : 0;
    setShowLoader(true);
    setTimeout(() => {
      fetchInventoryDeployedData({ ...payload, dp: dp, pageStart: (page * limit) });
    }, 30000)
  }
}, [authReducer.inventoryDeleteSite])

const doNavigate = (pathname, params={}) => {
  history.push({ pathname: pathname, search: `?${getEncodedURI(params)}` });
}

const handlePerPageChange = (e: any) => {
  let _perPage = parseInt(e.target.value);
  if (Number.isInteger(_perPage)) {
      let params: any = getDecodeURI(location?.search);
      params.page = 0;
      params.limit = _perPage;
      setPage(0);
      setLimit(_perPage);
      doNavigate(location.url, params);
      fetchInventoryDeployedData({...payload, pagesize:_perPage, pageStart:0});
  }
};

const handlePagination = (e, value) => {
  let params: any = getDecodeURI(location?.search);
  params.page = value-1;
  setPage(value-1)
  doNavigate(location.url, params);
  fetchInventoryDeployedData({...payload, pageStart:((value-1)*limit)})
};

const updatePageInfo = (page: number, limit: number, itemCount: number, pages: number, total: number) => {
  setPage(page);
  setFromItem(itemCount > 0 ? ((page) * limit) + 1 : 0);
  setToItem(((page) * limit) + itemCount);
  setTotal(total);
  setPages(pages);
};

const setSorting = (event: any, field: any, order: any,) => {
  if (event && event.currentTarget) {
      let params: any = getDecodeURI(location?.search);
      params.page = 0;
      params.sort = field;
      params.sortOrder = order;

      setPage(0);
      setSort(field);
      setSortOrder(order);

      doNavigate(location.url, params);
      fetchInventoryDeployedData({...payload, sortBy:field, sortOrder:order})
  }
};

const switchSorting = (event: any, field: any) => {
  let order = ASC_ORDER;
  if (sort === field) {
      order = ASC_ORDER === sortOrder ? DESC_ORDER : ASC_ORDER;
  }
  let params: any = getDecodeURI(location?.search);
  params.page = 0;
  params.sort = field;
  params.sortOrder = order;

  setPage(0);
  setSort(field);
  setSortOrder(order);
  
  doNavigate(location.url, params);
  fetchInventoryDeployedData({...payload,  sortBy:field, sortOrder:order})
};

useEffect(() => {
   if(!_.isEmpty(authReducer.inventoryDownloadConfig) && downloadConfig) {
     const url = authReducer?.inventoryDownloadConfig?.result;

      if(authReducer?.inventoryDownloadConfig?.success == true) {
       window.open(url);
       clearInventoryConfigDownload();
      } else if (!authReducer?.inventoryDownloadConfig?.success || authReducer?.inventoryDownloadConfig?.data?.success == false) {
      toast.error('Something went wrong, unable to download the file..', {
        position: toast.POSITION.BOTTOM_LEFT,
      });
     }
     authReducer.inventoryDownloadConfig = {};
    }
},[authReducer?.inventoryDownloadConfig])

const handleDownloadConfig = (row) => {
  setDownloadConfig(true);
  const siteId = row?.k4Id;
  const deviceId = row?.sn;
  const configId = row?.config_id
  inventoryDownloadConfig(siteId, deviceId, configId)
}

const changeGroup = () => {
  inventoryChangeGroup(selectedSiteId, ou?.id);
  setChangeGroupPopup(false);
}

const DownloadDeployedTable = () => {
  payload = { ...payload, pageStart: 0, pagesize: total, sortBy: sort, sortOrder: sortOrder }
  getInventoryDeployedData(payload, DOWNLOAD_INVENTORY_DEPLOYED_DATA);
}

const handleModifyConfig = (row, clickedIcon) => () => {
  if(row["konnect_status"] == "STATUS_NOT_CONNECTED"  || row.inprogressFlag){
    return
  }
  setClickedActionIcon(clickedIcon)
  setModifyConfigData({
    selectedDevice: {
      id: clickedIcon == BACKUP_CONFIG_NOW ? row["sn"] : row["deviceId"],
      name: row["deviceName"],
      productType: row["productType"],
    },
    selectedSite: row["k4Id"],
    selectedSiteName: row["name"],
    currentEOSversion: row["current_EOS_version"],
    latestEOSversion:  row["latestEOSavailable"]
  })
}

  const handleOnSearchClick = () => {
    doSearch(searchValue);
  }

  const handleOnSearchClear = () => {
    setSearchValue('');
    doSearch('');
  }

  const handleOnSearchChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setSearchValue(e.target.value);
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    searchTimeoutRef.current = setTimeout(() => {
      searchTimeoutRef.current = undefined;
      doSearch(e.target.value);
    }, 1000)
  }

  const handleDownloadReport = () => {
     // let isClickHouse = (window.location.host.includes("devch") || window.location.host.includes("stagech") || window.location.host.includes("prodch"))
     let isClickHouse = true;
     const apiUrl = isClickHouse ? `/store/pg/query` : `/store/ss/query`
    const { search, sortOrder, k4Ids, sortBy, deregQ } = payload;
    if (k4Ids.length === 0) {
      toast.error("No data available to download", {
        position: toast.POSITION.BOTTOM_LEFT,
      })
      return;
    }
    const vesselMap: any = k4Ids?.map((item: any) => item["id"])
    let k4idhere = vesselMap.length > 0 ? `${"'" + vesselMap.join("','") + "'"}` : null;
    let _userOu :any = localStorage.getItem('user_ou');
    const userOu = JSON.parse(_userOu)
    const params: CsvParameters = {
      type: isClickHouse? 'QUERY_CH' : "QUERY",
      id: 'inventory-deployed', //
      queryName: 'INVENTORY_DASHBOARD_V2',
      payload: {
        pageStart: 0,
        pagesize: total,
        search: search,
        sortBy: sortBy,
        sortOrder: sortOrder,
        dp: "",
        k4Ids: (k4idhere && k4idhere !== '') ? `${k4idhere}` : '',
        deregQ: deregQ || '',
        org: userOu?.name || '',
      }
    };
    downloadAsCSV(params);
  };
  
  const handleShowHistory = (deviceId, invId) => {
    setInventoryId(invId);
    setDeviceIdSelected(deviceId)
    setDeviceHistoryPopup(true);
  }

  const handleShowDeviceEosHistory = (row) => {
    if (_.isEmpty(row['current_EOS_version'])) {
      return
    }
    setDeviceIdSelected(row['sn'])
    setDeviceEosHistoryPopup(true);
  }
  const handleShowDeviceLicenseHistory = (row) => {
    setDeviceIdSelected(row['sn'])
    setSiteIdSelected(row["k4Id"])
    setDeviceLicenseHistoryPopup(true);
  }

  const handleCopyDID = (deviceId: string) => {
    console.log("handleCopyDID called with deviceId:", deviceId);
    
    try {
      // Validate input
      if (typeof deviceId !== "string" || deviceId.length < 6) {
        throw new Error("Invalid deviceId");
      }

      const devicePrefix = deviceId.substring(0, 2).toUpperCase();
      if (devicePrefix !== 'VX' && devicePrefix !== 'CH') {
        throw new Error('DID must start with VX or CH');
      }

      let encodedToken = '';

      // Check if this is the display format: VX1K{year}{month}AAAAA{serial} or CH1K{year}{month}AAAAA{serial}
      // Example: VX1K47AAAAA000136, VX1K5BAAAAA123456, CH1K47AAAAA000136
      const displayFormatMatch = deviceId.match(/^(VX|CH)1K([0-9A-F])([0-9A-F])AAAAA(\d{6})$/i);
      
      if (displayFormatMatch) {
        // Display format - need to ENCODE it to create the token
        const year = displayFormatMatch[2];
        const month = displayFormatMatch[3];
        const serial = displayFormatMatch[4];
        
        console.log("Display format detected.");
        console.log("Year:", year, "Month:", month, "Serial:", serial);
        
        // Create the year/month byte: 0x{year}{month}
        const yearMonthByte = parseInt(year + month, 16);
        
        // Split serial into 3 hex bytes (each 2 digits as hex)
        // Serial 000136 → 0x00, 0x01, 0x36
        // Note: The serial digits are treated as hexadecimal pairs
        const byte1 = parseInt(serial.substring(0, 2), 16); // First 2 digits as hex
        const byte2 = parseInt(serial.substring(2, 4), 16); // Middle 2 digits as hex
        const byte3 = parseInt(serial.substring(4, 6), 16); // Last 2 digits as hex
        
        // Create byte array
        const data = new Uint8Array([yearMonthByte, byte1, byte2, byte3]);
        
        console.log("Data bytes:", Array.from(data).map(b => '0x' + b.toString(16).padStart(2, '0')).join(' '));
        
        // Calculate check byte
        let check = 0;
        for (let i = 0; i < data.length; i++) {
          check += data[i];
        }
        const checkByte = check & 255;
        
        // Add check byte to data
        const finalData = new Uint8Array(5);
        finalData.set(data, 0);
        finalData[4] = checkByte;
        console.log("Final data with check byte:", Array.from(finalData).map(b => '0x' + b.toString(16).padStart(2, '0')).join(' '));
        
        // Base64 URL-safe encode
        const base64String = btoa(String.fromCharCode.apply(null, Array.from(finalData)));
        encodedToken = base64String
          .replace(/\+/g, '-')
          .replace(/\//g, '_')
          .replace(/=+$/, ''); // Remove padding
        
        console.log("Encoded token:", encodedToken);
      } else {
        // Already encoded format - token should be 7 characters after VX1K/CH1K + year + month
        // Example: VX1K5BWxI0Vvc or CH1K5BWxI0Vvc
        if (deviceId.length < 13) {
          throw new Error("Encoded DID must be at least 13 characters");
        }

        encodedToken = deviceId.substring(6, 13);
        console.log("Already encoded format. Token:", encodedToken);
      }

      // Copy encoded token to clipboard
      navigator.clipboard.writeText(encodedToken).then(() => {
        toast.success(`Token ${encodedToken} copied to clipboard!`, {
          position: toast.POSITION.BOTTOM_LEFT,
          autoClose: 2000,
        });
      }).catch((err) => {
        console.error('Failed to copy token:', err);
        toast.error('Failed to copy token', {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
    } catch (err) {
      console.error('Failed to encode/decode DID:', err);
      const errorMessage = err instanceof Error ? err.message : 'Unknown error';
      toast.error(`Failed to process DID: ${errorMessage}`, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  };
 

  const handleDeregQueueChange = (e) => {
    setIsDeregQueueChecked(e.target.checked);
    fetchInventoryDeployedData({
      ...payload,
      deregQ: e.target.checked ? "and deRegisteredQueueFlag=1" : "",
    });
  };

  useEffect(() => {
    if(!_.isEmpty(getInventorySyncData)) {
      const res = getInventorySyncData;
      if (res.hasOwnProperty("status") && res.status == 'DONE') {
        const dp = authReducer.selectedOu.name == "K4Mobility" ? "" : `and fullname IN ('${authReducer.selectedOu.name}')`;
        const page = _q.hasOwnProperty("page") ? parseInt(_q.page) : 0;
        if(locationIds?.length > 0) {
          fetchInventoryDeployedData({ ...payload, dp: dp, pageStart: (page * limit) });
        }
      }
      dispatch({type: GET_INVENTORY_SYNC_DATA, payload: {}})
    }
  }, [getInventorySyncData]);

  return (
    <div className="Form">
      <Grid className="am-table inventory-am-table">
        <Grid className="deployedContainer">
            <Grid className="topbarWidth alignTopbarItemsCenter">
            <Grid item xs={4} sm={4} md={4} lg={4} className="filterButtonMaxWidth">
  <Button variant="outlined" startIcon={<TuneIcon id="filterIcon"/>} onClick={(e) => { setAnchorElRef(e.currentTarget); setFilterPopup(true); }} id="filterButton">
    Filter
  </Button>
</Grid>





              <Grid item xs={6} sm={6} md={6} lg={6} className="searchbarMaxWidth1">
                <Box className="searchbarBox">
                  {<TextField
                      id="outlined-basic"
                      variant="outlined"
                      placeholder="Type something"
                      autoComplete="off"
                      size="small"
                      value={searchValue}
                      onChange={handleOnSearchChange}
                      onKeyDown={(event) => searchBoxKeyDown(event)}
                      InputLabelProps={{ className: "serachLabel" }}
                      InputProps={{
                          className: "searchbarInputs",
                          startAdornment: (
                              <InputAdornment position="start">
                                {!searchValue && <SearchIcon
                                  className="searchbarIconsPosition"
                                  onClick={handleOnSearchClick}
                                />}
                                {searchValue && <CloseIcon
                                  className="searchbarIconsPosition"
                                  onClick={handleOnSearchClear}
                                />}
                              </InputAdornment>
                          ),
                      }}
                  />}
                </Box>
              </Grid>




              
            {total > 0 && <Grid item xs={6} sm={6} md={6} lg={6} className="dwn-margin-auto">
              <div className="download-summary-btn marg-left-auto" onClick={handleDownloadReport}><img className="downloadImg" src={Download} alt="" /><Button>Download</Button></div>
            </Grid>}
          </Grid>
          <Menu
  disableEnforceFocus
  onClose={() => setFilterPopup(false)}
  open={filterPopup}
  className="rc--filter_menu_container_reports rc--filter_menu_container_login"
  anchorEl={anchorElRef}
  anchorOrigin={{
    vertical: "bottom",
    horizontal: "left"
  }}
  transformOrigin={{
    vertical: "top",
    horizontal: "center"
  }}
>
  <Grid className="usageFilterComponent">
  <InventoryFilters
  isDeregQueueChecked={isDeregQueueChecked}
  setIsDeregQueueChecked={setIsDeregQueueChecked}
  fetchInventoryDeployedData={fetchInventoryDeployedData}
  payload={payload}
  setFilterPopup={() => setFilterPopup(false)}
/>


  </Grid>
</Menu>

          {
            <div className="menuScroll">
              <Box>
                <Pagination
                  rowsPerPageOptions={NEW_PER_PAGE_ITEMS}
                  count={total ? total : 0}
                  rowsPerPage={limit}
                  page={page + 1}
                  onPageChange={handlePagination}
                  onRowsPerPageChange={handlePerPageChange}
                />
              </Box>
              <TableContainer className="usageReports-FleetDashboard loginHistory-tableContainer deployed-container white-bg deployed-table-headers" component={Paper}>
                <Table aria-label="simple sticky table" stickyHeader>
                  <TableHead className="usageReports-tableHead">
                    <TableRow className="UsageReports-tableRow login-tableRow">
                      <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                        <span className="align-items-center">
                          <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, VESSEL_NAME)}>SITE</span>
                          <Grid className="sort-icon-margin">
                            <img src={sort === VESSEL_NAME && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                              className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, VESSEL_NAME, ASC_ORDER)} />
                            <img src={sort === VESSEL_NAME && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                              className="sortingImages" onClick={(event) => setSorting(event, VESSEL_NAME, DESC_ORDER)} />
                          </Grid>
                        </span>
                      </TableCell>
                      <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                        <span className=" align-items-center">
                          <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, GROUP_NAME)}>Organization</span>
                          <Grid className="sort-icon-margin">
                            <img src={sort === GROUP_NAME && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                              className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, GROUP_NAME, ASC_ORDER)} />
                            <img src={sort === GROUP_NAME && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                              className="sortingImages" onClick={(event) => setSorting(event, GROUP_NAME, DESC_ORDER)} />
                          </Grid>
                        </span>
                      </TableCell>
                      <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                        <span className=" align-items-center">
                          <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, DEVICE_NAME)}>Device Name</span>
                          <Grid className="sort-icon-margin">
                            <img src={sort === DEVICE_NAME && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                              className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, DEVICE_NAME, ASC_ORDER)} />
                            <img src={sort === DEVICE_NAME && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                              className="sortingImages" onClick={(event) => setSorting(event, DEVICE_NAME, DESC_ORDER)} />
                          </Grid>
                        </span>
                      </TableCell>
                      <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                        <span className=" align-items-center">
                          <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, CURRENT_EOS_VERSION)}>EOS Version</span>
                          <Grid className="sort-icon-margin">
                            <img src={sort === CURRENT_EOS_VERSION && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                              className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, CURRENT_EOS_VERSION, ASC_ORDER)} />
                            <img src={sort === CURRENT_EOS_VERSION && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                              className="sortingImages" onClick={(event) => setSorting(event, CURRENT_EOS_VERSION, DESC_ORDER)} />
                          </Grid>
                        </span>
                      </TableCell>
                      <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                        <span className=" align-items-center">
                          <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, PRODUCT_ID)}>DID</span>
                          <Grid className="sort-icon-margin">
                            <img src={sort === PRODUCT_ID && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                              className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, PRODUCT_ID, ASC_ORDER)} />
                            <img src={sort === PRODUCT_ID && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                              className="sortingImages" onClick={(event) => setSorting(event, PRODUCT_ID, DESC_ORDER)} />
                          </Grid>
                        </span>
                      </TableCell>
                      <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                        <span className=" align-items-center">
                          <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, LAST_SEEN)}>Last Seen</span>
                          <Grid className="sort-icon-margin">
                            <img src={sort === LAST_SEEN && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                              className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, LAST_SEEN, ASC_ORDER)} />
                            <img src={sort === LAST_SEEN && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                              className="sortingImages" onClick={(event) => setSorting(event, LAST_SEEN, DESC_ORDER)} />
                          </Grid>
                        </span>
                      </TableCell>
                      <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                        <span className=" align-items-center">
                          <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, REG_DATE)}>Reg. Date</span>
                          <Grid className="sort-icon-margin">
                            <img src={sort === REG_DATE && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                              className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, REG_DATE, ASC_ORDER)} />
                            <img src={sort === REG_DATE && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                              className="sortingImages" onClick={(event) => setSorting(event, REG_DATE, DESC_ORDER)} />
                          </Grid>
                        </span>
                      </TableCell>
                      <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                        <span className="login-history-dp-name font-wt-900">License</span>
                      </TableCell>
                      { localStorage.getItem("isBetaUser") === "true" ? <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                        <span className="login-history-dp-name font-wt-900">Warranty (Months)</span>
                      </TableCell> : null }
                      <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                        <span className=" align-items-center">
                          <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, LICENSE_EXP_DATE)}>License Exp. Date</span>
                          <Grid className="sort-icon-margin">
                            <img src={sort === LICENSE_EXP_DATE && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                              className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, LICENSE_EXP_DATE, ASC_ORDER)} />
                            <img src={sort === LICENSE_EXP_DATE && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                              className="sortingImages" onClick={(event) => setSorting(event, LICENSE_EXP_DATE, DESC_ORDER)} />
                          </Grid>
                        </span>
                      </TableCell>
                      <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                        <span className=" align-items-center">
                          <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, UPTIME_SINCE)}>Uptime Since</span>
                          <Grid className="sort-icon-margin">
                            <img src={sort === UPTIME_SINCE && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                              className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, UPTIME_SINCE, ASC_ORDER)} />
                            <img src={sort === UPTIME_SINCE && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                              className="sortingImages" onClick={(event) => setSorting(event, UPTIME_SINCE, DESC_ORDER)} />
                          </Grid>
                        </span>
                      </TableCell>
                      <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                        <span className=" align-items-center">
                          <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, CONFIG_BACK_UP_CREATE_TIME)}>Saved Config</span>
                          <Grid className="sort-icon-margin">
                            <img src={sort === CONFIG_BACK_UP_CREATE_TIME && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                              className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, CONFIG_BACK_UP_CREATE_TIME, ASC_ORDER)} />
                            <img src={sort === CONFIG_BACK_UP_CREATE_TIME && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                              className="sortingImages" onClick={(event) => setSorting(event, CONFIG_BACK_UP_CREATE_TIME, DESC_ORDER)} />
                          </Grid>
                        </span>
                      </TableCell>
                     {!isReadOnlyUser && <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                        <span className="">
                          <span className="login-history-dp-name font-wt-900">Operations</span>
                        </span>
                      </TableCell>}
                    </TableRow>
                  </TableHead>
                  {inventoryDeployedData && 0 != inventoryDeployedData.length ? (
                    <TableBody className="tableBody usage-tableBody">
                      {
                        inventoryDeployedData && inventoryDeployedData.map((row, i) => {
                          let isValidTier = handleValidateTier(row)
                          return (
                            <TableRow key={i} className="loginHistory-tableRow new-deployed-usage-tr">
                                <TableCell className="login-left-align inter-font selectedClick text-center CF-cell">
                                  <div className="konnectStatus-site-cell">
                                    {row['sn'].substring(0, 2) !== "AM" ? <CircleIcon id={!isValidTier ? "greyDotSymbol" : row["konnect_status"] == "STATUS_CONNECTED" ? "greenDotSymbol" : (row["konnect_status"] == "STATUS_NOT_CONNECTED" || row['konnect_status'] == 'STATUS_NOT_FOUND') ? "redDotSymbol" : "greyDotSymbol"} /> : null}
                                    <span className="inventory-site-name-with-action-inprogress-icon">
                                      {isValidTier ? (
                                        <Link to={redirectToTopolgyTabs(location, "/fleet-dashboard/sites/topology", row?.k4Id, row?.name, {}, true, true)} style={{ textDecoration: "none" }}>
                                          <Tooltip title={<span className="font-size-12px">{row['name']}</span>}>
                                            <span className="inventory-ellipsis">{row['name']}</span>
                                          </Tooltip>
                                        </Link>
                                      ) : (
                                        <Tooltip title={<span className="font-size-12px">{row['name']}</span>}>
                                            <span className="inventory-ellipsis" style={{cursor: "auto"}}>{row['name']}</span>
                                          </Tooltip>
                                      )}
                                      {
                                        row.hasOwnProperty("inprogressFlag") && row.inprogressFlag
                                        ?
                                          <span className="inventoryDeployedAction upload-config-icon warningIcon" title={(row?.action) + ":" + (!_.isEmpty(row.action_status) ? (row?.action_status.length > 1 ? row.action_status.charAt(0).toUpperCase() + row.action_status.slice(1) : row.action_status) : null)}>
                                            <img src={UpdatesGoingOn} />
                                          </span>
                                        : null
                                      }
                                    </span>
                                  </div>
                                </TableCell>
                              <Tooltip title={<span className="font-size-12px">{row['hierarchy'] ? row['hierarchy'].replace(/\//g, ' / ') : row['dpname']}</span>}>
                                <TableCell className="login-left-align inter-font text-center CF-cell inventory-ellipsis">
                                  <span className="selectedClick">{row?.dpname}</span>
                                </TableCell>
                              </Tooltip> 
                              <Tooltip title={<span className="font-size-12px">{row['deviceName']}</span>}>
                                <TableCell className="login-left-align inter-font text-center CF-cell inventory-ellipsis">{row['deviceName']}</TableCell>
                              </Tooltip>  
                              {/* <TableCell className={_.isEmpty(row['current_EOS_version']) ? "login-left-align inter-font text-center CF-cell":"login-left-align inter-font text-center CF-cell selectedClick"}>
                                <div style={{ textDecoration: "none" }} onClick={() =>  handleShowDeviceEosHistory(row)}>
                                  {row['current_EOS_version']}
                                </div>
                              </TableCell> */}
                              <TableCell className="login-left-align inter-font text-center CF-cell inventory-ellipsis">{row['current_EOS_version']}</TableCell>
                              <TableCell className='login-left-align inter-font CF-cellt selectedClick'>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <Tooltip title={ localStorage.getItem("isBetaUser") === "true" ? <span className="font-size-12px">Warrany Start Date: {row['warrantyStartDate']}</span> : null}>
                                    <div style={{ textDecoration: "none" }} onClick={() =>  handleShowHistory(row['sn'], row['inventoryId'])}>
                                      {row['sn']}
                                    </div>
                                  </Tooltip>
                                  {(row['sn']?.toUpperCase().startsWith('VX') || row['sn']?.toUpperCase().startsWith('CH'))  && (
                                    <Tooltip title={<span className="font-size-12px">Generate Token</span>}>
                                      <IconButton
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleCopyDID(row['sn']);
                                        }}
                                        style={{ padding: '4px' }}
                                      >
                                        <img src={TokenGenration} alt="Generate Token" style={{ width: '20px', height: '20px' }} />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </div>
                              </TableCell>
                              <Tooltip title={<span className="font-size-12px">{convertDateTimeIntoTimezone(row['last_seen'], authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS)}</span>}>
                                <TableCell className="login-left-align inter-font text-center CF-cell">
                                  {convertDateTimeIntoTimezone(row['last_seen'], authReducer.userTimezone, DEFAULT_DATE_FORMAT)}
                                </TableCell>
                              </Tooltip>
                              <TableCell className="login-left-align inter-font text-center noWrap CF-cell">
                                {convertDateTimeIntoTimezone(row['dateRegistered'], authReducer.userTimezone, DEFAULT_DATE_FORMAT)}
                              </TableCell>
                              {
                                row["sn"].startsWith("AM")
                                ? <TableCell className="login-left-align inter-font text-center CF-cell">{row['licenseType'] == 'Paused' ? `${row['tierAlias']} (Paused)` : row?.['tierAlias']}</TableCell>
                                : <TableCell className="login-left-align inter-font text-center CF-cell selectedClick">
                                    <div style={{ textDecoration: "none" }} onClick={() =>  handleShowDeviceLicenseHistory(row)}>
                                      {row['licenseType'] == 'Paused' ? `${row['tierAlias']} (Paused)` : row?.['tierAlias']}
                                    </div>
                                  </TableCell>
                              }
                              { localStorage.getItem("isBetaUser") === "true" ? <TableCell className="login-left-align inter-font text-center CF-cell">{row['warranty']}</TableCell> : null }
                              {
                                !_.isEmpty(row?.tierAlias) && !_.isEmpty(row?.termDisplay)
                                ? <Tooltip title={<span style={{ fontSize: "12px" }}>{`License: ${row['tierAlias']}`}<br/>{`Term: ${row['termDisplay']}`}</span>}>
                                    <TableCell className='login-left-align inter-font text-center CF-cell' style={row?.['isExpiringSoon'] ? {color: 'red'} : {}}>
                                    {row?.termValue == -1 ? 'N/A' : convertDateTimeIntoTimezone(row['license_expiry_date'], authReducer.userTimezone, DEFAULT_DATE_FORMAT)}
                                  </TableCell>
                                  </Tooltip>
                                : <TableCell className='login-left-align inter-font text-center CF-cell' style={row?.['isExpiringSoon'] ? {color: 'red'} : {}}>
                                    {convertDateTimeIntoTimezone(row['license_expiry_date'], authReducer.userTimezone, DEFAULT_DATE_FORMAT)}
                                  </TableCell>
                              }
                              <Tooltip title={<span className="font-size-12px">{convertDateTimeIntoTimezone(row['uptime_date'], authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS)}</span>}>
                                <TableCell className="login-left-align inter-font text-center CF-cell">
                                  {convertDateTimeIntoTimezone(row['uptime_date'], authReducer.userTimezone, DEFAULT_DATE_FORMAT)}
                                </TableCell>
                              </Tooltip>
                              <Tooltip title={row['saved_config_file_name']}>
                                <TableCell className="login-left-align inter-font text-center noWrap CF-cell selectedClick">
                                    <span onClick={() => handleDownloadConfig(row)}>{convertDateTimeIntoTimezone(row['create_time'], authReducer.userTimezone, DEFAULT_DATE_FORMAT)}</span>
                                </TableCell>
                              </Tooltip>
                              {!isReadOnlyUser && <TableCell className="login-left-align inter-font noWrap text-center deployed-action">
                                { row['sn'].substring(0, 2) !== "AM" ? 
                                  <span onClick={() => {setIsOpenEdgeDevice(row['sn']?.startsWith("RS") || row['sn']?.startsWith("RM") || false); setEditActionsPopup(!row['sn']?.startsWith("RS") && !row['sn']?.startsWith("RM")); setRow(row); setConfirmDialog({...confirmDialog, isOpen: false}); dispatch({type: TRACK_INVENTORY_SYNC_DATA, payload: {}}); dispatch({ type: GET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS, payload: {} })}}><SettingsIcon className="inventory-edit-icon" /></span>
                                  : <span><SettingsIcon className="greySettings"/></span>}
                              </TableCell>}
                            </TableRow>
                          )
                        }
                        )
                      }
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={12} className="noData" align="center">No data available</TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </div>
          }
        </Grid>
      </Grid>
      

      {editActionsPopup && !isOpenEdgeDevice ? <EditActionsPopup open={editActionsPopup} setOpen={setEditActionsPopup} row={row} isSelectedOuIsUserOu={isSelectedOuIsUserOu} isInventoryDeployedPage={true} handleValidateTier={handleValidateTier} confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} setRow={setRow} isAuthorizedToBeta={isAuthorizedToBeta} isOpenEdgeDevice={isOpenEdgeDevice} /> : null}
      { deviceHistoryPopup ? <DeviceHistoryPopup open={deviceHistoryPopup} setOpen={setDeviceHistoryPopup} deviceIdSelected={deviceIdSelected} inventoryId={inventoryId} /> : null}
      { deviceEosHistoryPopup ? <DeviceEosHistoryPopup open={deviceEosHistoryPopup} setOpen={setDeviceEosHistoryPopup} deviceIdSelected={deviceIdSelected} /> : null}
      { deviceLicenseHistoryPopup ? <DeviceLicenseHistoryPopup open={deviceLicenseHistoryPopup} setOpen={setDeviceLicenseHistoryPopup} deviceIdSelected={deviceIdSelected} siteIdSelected={siteIdSelected}/> : null}
      {isOpenEdgeDevice && <InventoryPopup open={isOpenEdgeDevice} setOpen={setIsOpenEdgeDevice} row={row} deviceName={row['deviceName']} isValidTier={handleValidateTier(row)} confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} isLicenseChanging={isLicenseChanging} onLicenseChangeSuccess={() => { isLicenseChangingRef.current = true; setIsLicenseChanging(true); fetchInventoryDeployedData(payload); }} />}
      {(showLoader || isLicenseChanging) && <CustomLoader
        showLoader={true}
        loadingText={"Please wait, this might take up to 40 seconds."}
      />}
    </div>
  )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    isReadOnlyUser: state?.authReducer?.isReadOnlyUser,
    getDeviceTransfer: state.authReducer.getDeviceTransfer,
    getInventorySyncData: state.authReducer.getInventorySyncData,
  });
  
  export default withRouter(
    connect(mapStateToProps, { getInventoryDeployedData, getInventoryDeployedDataCount, moveDeviceToWarehouse, deleteSite, inventoryDownloadConfig, clearInventoryConfigDownload, inventoryChangeGroup, backupConfigNow, updateUserOuHasSubOus, downloadAsCSV, rebootDevice })(InventoryDeployedTable)
  );
